export default function rangeSlider(sliderSelector) {
  const sliders = Array.from(document.querySelectorAll(sliderSelector));

  // Функция для форматирования числа с разделителями и добавления текста
  function formatNumberWithText(num, input) {
    if (num === undefined || num === null || !input) return '';
    const prefix = input.dataset.pref || '';
    const currency = input.dataset.currency || '';
    // Особый случай для нуля
    if (num === 0 || num === '0') {
      return `${prefix} 0 ${currency}`.trim();
    }
    const formattedNum = num.toString().replace(/\B(?=(\d{3})+(?!\d))/g, " ");
    return `${prefix} ${formattedNum} ${currency}`.trim();
  }

  // Функция для удаления форматирования (убирает все нецифровые символы и текст)
  function unformatNumber(str) {
    return str.replace(/[^\d]/g, '');
  }

  // Обновляет data-value атрибут
  function updateDataValue(input, value) {
    input.dataset.value = value;
  }

  sliders.forEach(slider => {
    const rangeInput = slider.querySelectorAll(".range-input input"),
          priceInput = slider.querySelectorAll(".price-input input"),
          range = slider.querySelector(".slider .progress");
    let priceGap = 100;

    priceInput.forEach((input) => {
      // Инициализация data-value
      updateDataValue(input, unformatNumber(input.value));

      // При фокусе убираем форматирование и текст для удобного редактирования
      input.addEventListener("focus", (event) => {
        event.target.value = unformatNumber(event.target.value);
      });
      
      // При потере фокуса добавляем форматирование и текст
      input.addEventListener("blur", (event) => {
        const unformattedValue = unformatNumber(event.target.value);
        if (unformattedValue === '') {
          event.target.value = '';
          updateDataValue(event.target, '');
          return;
        }
        const numValue = unformattedValue === '0' ? 0 : parseInt(unformattedValue);
        event.target.value = formatNumberWithText(numValue, event.target);
        updateDataValue(event.target, numValue);
        priceInputHandler(event);
      });
      
      // Обработчик ввода
      input.addEventListener("input", (event) => {
        // Удаляем все нецифровые символы при вводе
        const unformattedValue = unformatNumber(event.target.value);
        event.target.value = unformattedValue;
        const numValue = unformattedValue === '0' ? 0 : parseInt(unformattedValue || '0');
        updateDataValue(event.target, numValue);
        priceInputHandler(event);
      });
    });

    rangeInput.forEach((input) => {
      input.addEventListener("input", (event) => rangeInputHandler(event));
    });

    initRangeSlider();

    function initRangeSlider() {
      // Инициализация с форматированными значениями и текстом
      const minValue = unformatNumber(priceInput[0].value) || 0;
      const maxValue = unformatNumber(priceInput[1].value) || 0;
      
      priceInput[0].value = formatNumberWithText(minValue, priceInput[0]);
      priceInput[1].value = formatNumberWithText(maxValue, priceInput[1]);
      
      updateDataValue(priceInput[0], minValue);
      updateDataValue(priceInput[1], maxValue);
      
      priceInputHandler({target: priceInput[0]});
      priceInputHandler({target: priceInput[1]});
    }

    function priceInputHandler(event) {
      let minPrice = parseInt(priceInput[0].dataset.value) || 0,
          maxPrice = parseInt(priceInput[1].dataset.value) || 0;

      if (maxPrice - minPrice >= priceGap && maxPrice <= rangeInput[1].max) {
        if (event.target.classList.contains('input-min')) {
          const rangeInputMinAll = document.querySelectorAll(".range-input input.range-min");
          const priceInputMinAll = document.querySelectorAll(".price-input input.input-min");

          priceInputMinAll.forEach(inputMin => {
            inputMin.value = formatNumberWithText(minPrice, inputMin);
            updateDataValue(inputMin, minPrice);
          });

          rangeInputMinAll.forEach(rangeInput => {
            rangeInput.value = minPrice;
            const range = rangeInput.closest('.range-slider').querySelector('.slider .progress');
            range.style.left = (minPrice / rangeInput.max) * 100 + "%";
          });

        } else {
          const rangeInputMaxAll = document.querySelectorAll(".range-input input.range-max");
          const priceInputMaxAll = document.querySelectorAll(".price-input input.input-max");

          priceInputMaxAll.forEach(inputMin => {
            inputMin.value = formatNumberWithText(maxPrice, inputMin);
            updateDataValue(inputMin, maxPrice);
          });

          rangeInputMaxAll.forEach(rangeInput => {
            rangeInput.value = maxPrice;
            const range = rangeInput.closest('.range-slider').querySelector('.slider .progress');
            range.style.right = 100 - (maxPrice / rangeInput.max) * 100 + "%";
          });
        }
      }
    }

    function rangeInputHandler(event) {
      let minVal = parseInt(rangeInput[0].value),
          maxVal = parseInt(rangeInput[1].value);

      if (event.target === rangeInput[0]) {
        rangeInput[0].style.setProperty('--minThumbZIndex', '2');
        rangeInput[1].style.setProperty('--minThumbZIndex', '1');
      } else {
        rangeInput[0].style.setProperty('--minThumbZIndex', '1');
        rangeInput[1].style.setProperty('--minThumbZIndex', '2');
      }

      if (maxVal - minVal < priceGap) {
        if (event.target.className === "range-min") {
          rangeInput[0].value = maxVal - priceGap;
        } else {
          rangeInput[1].value = minVal + priceGap;
        }
      } else {
        const priceInputMinAll = document.querySelectorAll(".price-input input.input-min");
        const priceInputMaxAll = document.querySelectorAll(".price-input input.input-max");

        priceInputMinAll.forEach(priceInput => {
          priceInput.value = formatNumberWithText(minVal, priceInput);
          updateDataValue(priceInput, minVal);
          const range = priceInput.closest('.range-slider').querySelector('.slider .progress');
          const rangeInputMin = priceInput.closest('.range-slider').querySelector('.range-input input.range-min');
          rangeInputMin.value = minVal;
          range.style.left = (minVal / rangeInputMin.max) * 100 + "%";
        });

        priceInputMaxAll.forEach(priceInput => {
          priceInput.value = formatNumberWithText(maxVal, priceInput);
          updateDataValue(priceInput, maxVal);
          const range = priceInput.closest('.range-slider').querySelector('.slider .progress');
          const rangeInputMax = priceInput.closest('.range-slider').querySelector('.range-input input.range-max');
          rangeInputMax.value = maxVal;
          range.style.right = 100 - (maxVal / rangeInputMax.max) * 100 + "%";
        });
      }
    }
  });
}